import React, { useEffect } from 'react'

export default function Modal({ children }) {

    useEffect(() => {
        window.scrollTo(0, 0)
        document.body.style.overflow = "hidden"

        return () => {
            document.body.style.overflow = "auto"
        }
    }, [])

    return (
        <div className='flex justify-center items-center absolute top-0 left-0 w-full h-screen bg-slate-900/60 backdrop-blur-sm overflow-y-auto'>
            <div className='w-[90%] md:w-9/12'>
                {children}
            </div>
        </div>
    )
}
